import React from "react";

export default function HealthRecord() {
  return <div>HealthRecord</div>;
}
